import Markdown from "markdown-to-jsx";
import LinkListItem from "./LinkListItem";
import styles from "./LinkListSection.module.scss";

export default function LinkListSection({ linkSection }) {
  const { name, description } = linkSection;

  const listItems =
    linkSection.link_item.map((item, index) => (
      <LinkListItem item={item} key={`${item.id}-${index}`} />
    )) ?? null;
  return (
    <div className={`${styles.container}`}>
      {name && <h3>{name}</h3>}{" "}
      {description && <Markdown>{description}</Markdown>}
      <ul className={`${styles.linkList}`}>{listItems && listItems}</ul>
    </div>
  );
}
